const format = {
    label: 'Sparkplug', 
    value: 'application/sparkplug'
}

export { format };


// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/formats/sparkplug/index.js